import { TResetPasswordType, TSetResetPasswordDataType } from '../../actions/resetPassword';

export const RESET_PASSWORD_TYPE: TResetPasswordType = 'resetPassword/status_changed';
export const SET_RESET_PASSWORD_DATA: TSetResetPasswordDataType = 'resetPassword/set_data';
